module.exports = __webpack_public_path__ + "img/change-bg.986cd9c5.png";